



































































































































































































































































































































































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
// 混入
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
// 接口
import {
  returnList,
  orderList,
  orderUpdateRemark,
  orderUpdateStatus,
  orderSendExpress,
  selectExpress,
  selectOrderByMainId,
  selectExpressByOrderId,
  updateShippingMethod
} from "@/api/order";
import { expressCompanyList } from "@/api/freight";

// 工具
import copy from "@/utils/deepCopy";
import filterPrice from "@/utils/inputPrice";
// ts
import { TableInitForm, initOptions, initForm } from "../type/index";

@Component({
  components: {},
})
export default class Table extends Mixins(loading, tablePagination) {
  // 父组件传值
  @Prop() private fromDate!: string;
  @Prop() private toDate!: string;
  @Prop() private nickname!: string;
  @Prop() private phone!: string;
  @Prop() private receiverName!: string;
  @Prop() private receiverPhone!: string;
  @Prop() private orderId!: string;
  @Prop() private productName!: string;
  @Prop() private payType!: number;
  @Prop() private orderStatus!: any;
  @Prop() private shippingMethod!: string;
  @Prop() operationMemberId!: number|null;
  @Prop() serviceId!: number|null;
  @Prop() subCompanyId!: number|null;
  // 构造器自有属性
  tableData: Array<any> = []; // 订单列表
  orderDetail: Array<any> = []; // 订单详情
  dialogVisible: boolean = false; // 对话框显示订单详情
  dialogVisibleRemark: boolean = false; // 订单备注对话框
  dialogVisibleSend: boolean = false; // 发货对话框
  dialogVisibleSendData:any = {}; 
  form: TableInitForm = copy(initForm);
  type: string = "remark";
  options = copy(initOptions);
  // 物流信息
  initActivities: Array<{
    acceptStation: string;
    acceptTime: string;
    color?: string;
  }> = [
    {
      acceptStation: "已签收",
      acceptTime: "2018-04-15",
      color: "#f56c6c",
    },
  ];
  activities: Array<{
    acceptStation: string;
    acceptTime: string;
    color?: string;
  }> = [];
  disabled: boolean = false;
  expressCompanyList_: any = [];
  activeName: string = "1";
  /**
   * 生命周期
   */
  mounted() {
    this.getData();
    this.getExpressCompany();
  }
  /**
   * methods
   */
  getData() {
    this.showLoading();

    let tempOrderStatus = this.orderStatus;
    if (tempOrderStatus == 20) {
      tempOrderStatus = '';
    }

    if(tempOrderStatus == 12){
      tempOrderStatus = '';
      returnList({
        fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
        toDate: this.fromDate && this.fromDate.toString().split(",")[1],
        nickname: this.nickname,
        phone: this.phone,
        receiverName: this.receiverName,
        receiverPhone: this.receiverPhone,
        orderId: this.orderId,
        productName: this.productName,
        payType: this.payType,
        orderStatus: tempOrderStatus,
        shippingMethod: this.shippingMethod,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        operationMemberId: this.operationMemberId,
        serviceId: this.serviceId,
        subCompanyId: this.subCompanyId
    }).then((res: any) => {
      res.data.list.forEach((e: any, index: number) => {
        e.visible = false;
        e.activities = [];
        // this.showFreight(e, index, null);
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
    });

      return;
    }

    orderList({
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      toDate: this.fromDate && this.fromDate.toString().split(",")[1],
      nickname: this.nickname,
      phone: this.phone,
      receiverName: this.receiverName,
      receiverPhone: this.receiverPhone,
      orderId: this.orderId,
      productName: this.productName,
      payType: this.payType,
      orderStatus: tempOrderStatus,
      shippingMethod: this.shippingMethod,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      operationMemberId: this.operationMemberId,
      serviceId: this.serviceId,
      subCompanyId: this.subCompanyId
    }).then((res: any) => {
      res.data.list.forEach((e: any, index: number) => {
        e.visible = false;
        e.activities = [];
        // this.showFreight(e, index, null);
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
    });
  }
  // 查看详情
  viewDetail(item: any) {
    let orderId = item.id;
    this.$router.push({
      path: "/orderDetail",
      query: { orderId: orderId },
    });
  }

  getItemClass(index:number,len:number){
      if(index  == len - 1){
        return 'order-item order-item-last';
      }

       return 'order-item';
  }

 viewReturnDetail(omsOrderItem: any) {
    let orderId = omsOrderItem.id;
    this.$router.push({
      path: "/returnDetail",
      query: { orderId: orderId },
    });
  }

  viewAfterDetail(omsOrderItem: any) {
    let orderId = omsOrderItem.id;
    this.$router.push({
      path: "/afterDetail",
      query: { orderId: orderId },
    });
  }

  // 修改订单状态
  updateStatus(row: any, type: string) {
    this.dialogVisibleSendData = row;
    console.log(this.dialogVisibleSendData)
    if (row.shippingMethod == 1 && row.status == 3) {
      this.type = 'express';
      this.dialogVisibleSend = true;
    } else if (row.shippingMethod == 2 && row.status == 3) {
      this.type = 'take';
      this.dialogVisibleSend = true;
      // this.$confirm("客户是否上门自提货物?", "自提发货", {
      //   confirmButtonText: "是的",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   orderUpdateStatus({
      //     id: row.id,
      //     status: 9, // 已完成
      //   }).then((res: any) => {
      //     this.getData();
      //     this.$message({
      //       type: "success",
      //       message: "设置成功!",
      //     });
      //   });
      // });
    } else {
      // this.options = initOptions.filter((e) => e.value > row.status);
      // this.type = "status";
      // this.dialogVisibleRemark = true;
    }
    this.form.id = row.id;
  }
  // 修改备注
  updateRemark(row: any) {
    this.type = "remark";
    this.form.remark = row.note;
    this.form.id = row.id;
    this.dialogVisibleRemark = true;
  }
  // 确认修改修改订单
  async confirmUpdate(row: any) {
    let pro: any = null;
    let form = this.form;
    switch (this.type) {
      case "remark":
        pro = await orderUpdateRemark(form);
        break;
      case "status":
        if (
          form.status == 7 ||
          form.status == 9 ||
          form.status == 11 ||
          form.status == 13
        ) {
          pro = await orderUpdateStatus({
            id: form.id,
            status: form.status,
          });
        } else {
          this.$message.error("选择状态有误");
          return;
        }
        break;
      case "express":
        if(form.take){
          await updateShippingMethod({
              orderId: form.id,
              status: 2
             }); 
         await orderUpdateStatus({
              id: form.id,
              status: 9, // 已完成
            });
        }else{
        let name = this.expressCompanyList_.find(
          (e: { id: number }) => e.id == form.expressId
        );
        pro = await orderSendExpress({
          orderId: form.id,
          expressName: name && name.expressName,
          expressNo: form.expressNo,
          expressId: form.expressId,
        });
        }
        this.viewDetail(form);
        break;
      case "take":
      await orderUpdateStatus({
          id: form.id,
          status: 9, // 已完成
        })
         this.viewDetail(form);
      break;
      default:
        break;
    }
    this.$message.success(this.type == "express" ? "发货成功" : "修改成功");
    this.dialogVisibleRemark = false;
    this.getData();
    this.form = copy(initForm);
  }
  // 取消
  cancelUpdate() {
    this.dialogVisibleRemark = false;
    this.form = initForm;
  }
  // 显示物流
  showFreight(row: any, index: number, event: any) {
    // this.activities = [];
    if (row.status >= 3) {
      selectExpressByOrderId({ orderId: row.id }).then((res: any) => {
        try {
          this.tableData[index].omsOrderExpress = res.data;
          this.tableData[index].activities =
            (res.data && res.data.tracesObj) || [];
        } catch (error) {}
      });
    }
  }
  hideFreight(index: number) {
    this.tableData[index].visible = false;
  }
  // 获取快递公司
  getExpressCompany() {
    expressCompanyList().then((res) => {
      this.expressCompanyList_ = res.data;
    });
  }
  // 对话框关闭前
  beforeClose() {
    this.activeName = "1";
    this.dialogVisible = false;
  }
}
